const apiUrl = process.env.REACT_APP_API_URL;

// ---------------- CEP --------------------------------
export async function getCep(cep) {
  
  const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);

  return response;
}

// ---------------- AUTH --------------------------------
export async function login(username, password) {

  const response = await fetch(`${apiUrl}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password }),
  });

  return response;
}

export async function signUp(form) {

  const response = await fetch(`${apiUrl}/auth/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(form),
  });

  return response;
}

export async function recoverPassword(email) {

  const response = await fetch(`${apiUrl}/auth/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email })
  });

  return response;
}

export async function changePassword(newPassword, token) {

  const response = await fetch(`${apiUrl}/auth/new-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ newPassword, token })
  });

  return response;
}

export async function getUser() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/auth/get-user-info`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  return response;
}

export async function getUsers() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/auth/get-users`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  return response;
}

export async function updateProfile(profileData) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/auth/update-profile`, {
    method: 'PUT', 
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(profileData),
  });

  return response;
}

// ---------------- BOOKINGS --------------------------------
export async function getBookings() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/bookings/get-bookings`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return response;
}

export async function getUserBooking() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/bookings/get-user-bookings`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return response;
}

export async function deleteUserBooking(id) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/bookings/delete-booking/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return response;
}

export async function createUserBooking(bodyData) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/bookings/create-booking`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyData),
  });

  return response;
}

// ---------------- COUPONS --------------------------------
export async function getUserCoupons() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/coupons/get-user-coupons`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return response;
}

export async function validateCoupon(code) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/coupons/validate-coupon?couponCode=${code}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return response;
}

// ---------------- ADMIN --------------------------------
export async function adminUserCount() {
 
  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/get-users-count`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return response;
}

export async function adminUpdateUserRole(username, role) {
 
  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/update-user-role`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ username, role })
  });

  return response;
}

export async function adminGetCoupons() {
 
  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/get-coupons`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return response;
}

export async function adminCreateCoupon(bodyData) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/create-coupon`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyData),
  });

  return response;
}

export async function adminDeleteCoupon(couponId) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/delete-coupon/${couponId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminGetBookingsDetails() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/get-bookings-details`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminGetBookingsPerDate(date) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/get-bookings-details/${date}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminCancelBooking(bookingId, refund) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/cancel-booking`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ bookingId, refund })
  });

  return response;
}

export async function adminGetBlockedDates() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/get-blocked-dates`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminCreateBlockedDate(bodyData) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/create-blocked-date`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyData),
  });

  return response;
}

export async function adminDeleteBlockedDate(id) {
 
  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/cancel-blocked-date/${id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminGetSpecialDates() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/get-special-dates`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminCreateSpecialDate(bodyData) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/create-special-date`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyData),
  });

  return response;
}

export async function adminDeleteSpecialDate(id) {
 
  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/cancel-special-date/${id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminGetBookingConfig() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/bookings-config`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminUpdateBookingConfig(bodyData) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/update-bookings-config`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyData),
  });

  return response;
}

export async function adminGetBookingHistory(username) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/get-booking-history/${username}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminGetBlockedUsers() {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/get-blocked-users`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminUnblockBlockedUsers(userId) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/unblock-user/${userId}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}

export async function adminDeleteBlockedUsers(userId) {

  const token = localStorage.getItem('token');

  const response = await fetch(`${apiUrl}/admin/delete-blocked-user/${userId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  });

  return response;
}
